import { t } from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getLocations } from './data';
import { errorReceiveLocations, failedReceiveLocations, receiveLocations } from './slice';
export function* requestLocations(action) {
    try {
        const { consumerAPI } = action.payload;
        const response = yield call(getLocations, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveLocations());
            }
            else if (data) {
                if (data.length < 1) {
                    throw new Error(t('NO_LOCATIONS_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveLocations(data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveLocations());
            }
            else if (response && response.status === 200) {
                if (response.data.length < 1) {
                    throw new Error(t('NO_LOCATIONS_AVAILABLE', {
                        ns: 'Common'
                    }));
                }
                yield put(receiveLocations(response.data));
            }
            else {
                throw new Error(t('NO_DATA_AVAILABLE', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveLocations());
    }
}
export function* watchRequestLocations() {
    yield takeLatest('locations/requestLocations', requestLocations);
}
